import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { useMandatoryTypeValidator } from "../validator";
import { Country } from "../../../../api/commercial/generated-types";

export function useCityValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();
  return Yup.string()
    .nullable()
    .matches(
      /^\D+$/,
      getMessage(
        "Validation.message-mustContainOnlyLettersAndSpecialCharacters",
      ),
    )
    .max(30, getMessage("Validation.message-maxLengthCharacters", 30))
    .required(getMessage("Validation.message-required"));
}

export function useSwissZipCodeValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();
  return Yup.string()
    .nullable()
    .length(4, getMessage("Validation.message-exactLengthCharacters", 4))
    .matches(/^\d+$/, getMessage("Validation.message-mustContainDigits"))
    .required(getMessage("Validation.message-required"));
}

export function useNonSwissZipCodeValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();
  return Yup.string()
    .nullable()
    .max(10, getMessage("Validation.message-maxLengthCharacters", 10))
    .matches(
      /^[a-zA-Z0-9]+$/,
      getMessage("Validation.message-mustNotContainSpecialChars"),
    )
    .required(getMessage("Validation.message-required"));
}

export function useZipCodeValidator(): Yup.StringSchema {
  const swissZipCodeValidator = useSwissZipCodeValidator();
  const nonSwissZipCodeValidator = useNonSwissZipCodeValidator();

  return Yup.string().when("country", {
    is: (country: Country) => country?.alpha2 === "CH",
    then: () => swissZipCodeValidator,
    otherwise: () => nonSwissZipCodeValidator,
  });
}

export function useAddressValidator() {
  return Yup.object().nullable().shape({
    zipCode: useZipCodeValidator(),
    country: useMandatoryTypeValidator(),
    city: useCityValidator(),
  });
}
